// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title[data-v-92c08098]{font-family:var(--babri-font-secondary,\"Goldplay\"),sans-serif}.need-help[data-v-92c08098]{font-family:var(--babri-font-primary,\"Proxima Nova\"),sans-serif;color:#235ba8!important;font-size:var(--barbri-base-font-size)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
